import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  bottom: 2px;\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// @ts-nocheck
import React from 'react';
import { Popover } from 'reakit';
import styled from '../utils/styling/styled-components';
// @ts-ignore
var StyledTooltipArrow = styled(Popover.Arrow)(_templateObject(), function (props) {
  return props.theme.colors.slate;
});

var TooltipArrow = function TooltipArrow(_ref) {
  var position = _ref.position,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledTooltipArrow, {
    position: position,
    className: className
  });
};

export { TooltipArrow };